/**
 * In-memory access-token holder.
 *
 * The access token lives ONLY in memory (module closure) — never localStorage /
 * sessionStorage — to keep it out of reach of XSS. The refresh token is a
 * backend-set HTTP-only cookie that JS cannot read. On page reload the session
 * is restored via a silent refresh (see AuthProvider).
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
